export default "__VITE_ASSET__0ad8e2fd__"